import { ApplicationInfo } from './ApplicationInfo';
import { ApplicationVersion } from './ApplicationVersion';
import { ErrorInformationStorage } from './ErrorInformationStorage';
export function CreateApplicationInfo() {
    var _a;
    const elem = document.getElementById('startData');
    if (!elem) {
        return;
    }
    const dt = JSON.parse(elem.innerText);
    try {
        const appVersion = ApplicationVersion.createApplicationVersionByJson(dt.BVD);
        ApplicationInfo.BuildVersionData = appVersion;
    }
    catch (ex) { }
    ApplicationInfo.login_language_selector = dt.lls;
    ApplicationInfo.saveLastLogin = dt.SLL;
    ApplicationInfo.FrequencyLogsSending = dt.FLS;
    ApplicationInfo.ExternalResourse = dt.ER;
    ApplicationInfo.LoginScreenType = dt.LST;
    ApplicationInfo.LoginLanguage = dt.LL;
    ApplicationInfo.LoginToken = (_a = dt.LT) !== null && _a !== void 0 ? _a : null;
    ErrorInformationStorage.SetTimerValue(ApplicationInfo.FrequencyLogsSending);
    ErrorInformationStorage.SetBuildVersion(ApplicationInfo.BuildVersionData);
    elem.parentElement.removeChild(elem);
}
